export default __webpack_public_path__ + "static/chart_0-min-6945c3b19cded496a981d068f3affc39.jpg";